export default "__VITE_ASSET__BlWt7_Lm__"